import { render } from "./land_court_overview.html?vue&type=template&id=498eb5d6&external"
import script from "./land_court_overview.js?vue&type=script&lang=js&external"
export * from "./land_court_overview.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__